import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ExternalLink } from 'lucide-react';

const OnlineReservation = () => {
  const { t, language } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-yellow-50">
      {/* Header */}
      <section className="bg-gradient-to-r from-slate-900 to-slate-800 text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4 text-center">{t('onlineReservation')}</h1>
          <p className="text-xl text-gray-300 text-center max-w-2xl mx-auto">
            {language === 'tr' ? 'Rezervasyon sistemimizdeki tüm seçenekleri keşfedin' : 'Explore all options in our reservation system'}
          </p>
        </div>
      </section>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-12">
            <div className="text-center">
              <div className="w-24 h-24 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-8">
                <ExternalLink className="h-12 w-12 text-white" />
              </div>
              
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                {language === 'tr' ? 'Online Rezervasyon Sistemimiz' : 'Our Online Reservation System'}
              </h2>
              
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                {language === 'tr'
                  ? 'Rezervasyon sistemimizdeki tüm otelleri, turları ve hizmetleri görüntüleyin. Aşağıdaki bağlantıya tıklayarak rezervasyon yapmaya başlayabilirsiniz.'
                  : 'View all hotels, tours and services in our reservation system. You can start making a reservation by clicking the link below.'}
              </p>

              <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-xl p-6 mb-8">
                <p className="text-sm text-gray-600 mb-4">
                  {language === 'tr'
                    ? 'Rezervasyon sistemi bağlantısı buraya eklenecektir'
                    : 'Reservation system link will be added here'}
                </p>
                <div className="flex items-center justify-center space-x-2 text-amber-600 font-mono text-lg">
                  <span>https://reservation.sunkiss.com</span>
                </div>
              </div>

              <button className="bg-gradient-to-r from-amber-500 to-yellow-600 text-white px-8 py-4 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 inline-flex items-center space-x-2">
                <span>{language === 'tr' ? 'Rezervasyon Sistemine Git' : 'Go to Reservation System'}</span>
                <ExternalLink className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnlineReservation;